import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/machine-capacity", label: "Machine Capacity" },
  { to: "/industries", label: "Industries" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="global-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-md bg-[hsl(var(--background))]/85 border-b border-border" : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="inline-block w-2.5 h-2.5 bg-accent rounded-none group-hover:rotate-45 transition-transform" />
          <span className="font-serif text-xl md:text-2xl tracking-tight text-primary">MIM Engineering</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid="nav-link-item"
              className={({ isActive }) =>
                `text-sm tracking-wide link-underline ${isActive ? "text-primary font-medium" : "text-muted-foreground hover:text-primary"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/quote"
            data-testid="nav-quote-btn"
            className="hidden md:inline-flex items-center px-5 py-2.5 text-sm tracking-wider uppercase bg-primary text-primary-foreground hover:bg-accent transition-colors"
          >
            Request a Quote
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden p-2 text-primary"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-[hsl(var(--background))]">
          <div className="container-x py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid="nav-link-item-mobile"
                className={({ isActive }) =>
                  `text-base ${isActive ? "text-primary font-medium" : "text-muted-foreground"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/quote" data-testid="nav-quote-btn-mobile" className="mt-2 inline-flex w-fit px-5 py-2.5 text-sm uppercase tracking-wider bg-primary text-primary-foreground">
              Request a Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
